export default __webpack_public_path__ + "static/media/bg.c6e9b423.png";